import React, { useState, useEffect } from 'react';

// material-ui
import {
    Typography,
    Grid,
    Avatar,
    Tooltip,
    IconButton,
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteAlert from './DeleteAlert';
import KeyIcon from '@mui/icons-material/Key';

// project import
import ChangePassword from './ChangePassword';
import { USER_TYPE, USER_STATUS } from 'store/constant';
import ColoredDropdown from './SimpleSpeedDials';

// third party
import moment from 'moment';
import UserService from 'services/UserService';
import useApi from 'hooks/useApi';

export const UserList = ({ setReload, rows, page, limit, userType, handleUserOpenDialog }) => {

    const [selectedUuid, setSelectedUuid] = useState('');
    const [open, setOpen] = useState(false);

    const handleOpen = (userUuid) => {
        setSelectedUuid(userUuid);
    };

    const handleClose = () => {
        setSelectedUuid('');
        setOpen(false);
    };

    const changeStatus = (rowUuid) => {
        changeUserStatusApi.execute(rowUuid);
    };

    const changeStatusHandler = () => {
        setReload(r => !r);
    };

    const changeUserStatusApi = useApi(UserService.changeUserStatusByUuid, changeStatusHandler, true);

    useEffect(() => {
        if (selectedUuid) {
            setOpen(true);
        }
    }, [selectedUuid]);

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow >
                        <TableCell sx={{ pl: 3 }}>#</TableCell>
                        <TableCell sx={{ whiteSpace: 'nowrap' }}>{userType === USER_TYPE[1].value ? 'Customer' : 'Manager'} Name</TableCell>
                        <TableCell sx={{ textAlign: 'center', whiteSpace: 'nowrap', paddingLeft: '80px' }}>Phone</TableCell>
                        {userType === USER_TYPE[0].value && <TableCell>Venue</TableCell>}
                        {userType === USER_TYPE[0].value && <TableCell>Email</TableCell>}
                        <TableCell sx={{ textAlign: 'center' }}>DOB</TableCell>
                        <TableCell sx={{ textAlign: 'center' }}>Gender</TableCell>
                        <TableCell sx={{ textAlign: 'center' }}>City</TableCell>
                        <TableCell sx={{ textAlign: 'center' }}>Status</TableCell>
                        <TableCell sx={{ textAlign: 'center' }}>Created At</TableCell>
                        <TableCell sx={{ textAlign: 'center', whiteSpace: 'nowrap' }}>Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        rows.map((row, index) =>
                            <TableRow hover key={index}>
                                <TableCell sx={{ pl: 3 }}>{page * limit - limit + index + 1}</TableCell>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                    <Grid container spacing={2} alignItems="center">
                                        <Grid item>
                                            <Avatar alt="Venue" src={row.image} />
                                        </Grid>
                                        <Grid item xs zeroMinWidth>
                                            <Typography align="left" variant="subtitle1" component="div">
                                                {row.firstname} {row.lastname}
                                            </Typography>
                                            <Typography align="left" variant="subtitle2">
                                                {row.code}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                                <TableCell sx={{ textAlign: 'center', whiteSpace: 'nowrap', paddingLeft: '80px' }}>+{row.countrycode} {row.phone}</TableCell>
                                {userType === USER_TYPE[0].value && <TableCell sx={{ whiteSpace: 'wrap' }}>{row.venues}</TableCell>}
                                {userType === USER_TYPE[0].value && <TableCell>{row.email}</TableCell>}
                                <TableCell sx={{ textAlign: 'center' }}>{row.dob ? moment(row.dob).format('DD-MM-YYYY') : ''}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>{row.gender}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>{row.loc_city}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>
                                    <ColoredDropdown
                                        itemArray={USER_STATUS}
                                        selectedValue={row.active}
                                        rowUuid={row.uuid}
                                        handleChange={changeStatus}
                                    />
                                </TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>
                                    {row.created_at ? moment(row.created_at).format('DD-MM-YYYY HH:mm:ss') : ''}
                                </TableCell>
                                <TableCell sx={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
                                    {
                                        USER_TYPE[0].value === row.type ? (
                                            <Tooltip placement="top" title="Change Password">
                                                <IconButton
                                                    color="primary"
                                                    aria-label="change-password"
                                                    size="large"
                                                    onClick={() => handleOpen(row.uuid)}
                                                >
                                                    <KeyIcon sx={{ fontSize: '1.5rem' }} />
                                                </IconButton>
                                            </Tooltip>
                                        ) : (<></>)
                                    }
                                    <Tooltip placement="top" title="Edit">
                                        <IconButton
                                            color="primary"
                                            aria-label="edit"
                                            size="large"
                                            onClick={() => handleUserOpenDialog(row.uuid)}
                                        >
                                            <EditIcon sx={{ fontSize: '1.1rem' }} />
                                        </IconButton>
                                    </Tooltip>
                                    <DeleteAlert setReload={setReload} userUuid={row.uuid} />
                                </TableCell>
                            </TableRow>
                        )
                    }
                </TableBody >
            </Table >
            <ChangePassword selectedUuid={selectedUuid} open={open} handleClose={handleClose} setReload={setReload} />
        </TableContainer >
    )
}